import { Customer, LandingContent } from 'types'
import axios from 'axios'
import { PATHS } from 'enums'
import contentData from '../../data/data.json'
import {
  requestInterceptorErrorSecurityAdministration,
  requestInterceptorSuccessAdministration,
  responseInterceptorErrorAdministration,
  responseInterceptorSuccessAdministration,
} from 'interceptors'

const instance = axios.create({
  baseURL: process.env.REACT_APP_ADMINISTRATION_BASE_API_URL,
})

instance.interceptors.request.use(
  requestInterceptorSuccessAdministration,
  requestInterceptorErrorSecurityAdministration
)

instance.interceptors.response.use(
  responseInterceptorSuccessAdministration,
  responseInterceptorErrorAdministration
)

export const getLandingContent = async (): Promise<LandingContent> => {
  try {
    const response = await instance.get<LandingContent>(PATHS.DATA_LANDING_FILE)
    return response.data
  } catch (error: any) {
    return contentData as LandingContent
  }
}

export const uploadDataLanding = async (customer: Customer) => {
  try {
    const response = await instance.post(PATHS.OFFER_LANDING, customer)
    return response.data
  } catch (error: any) {
    console.log(error)

    throw new Error(error.response?.data?.message ?? error.message)
  }
}
